import { url } from '../../../config/global';
import Axios from 'axios';

function DashboardAction(action, token, data = null) {
    const accessToken = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };

    const params = new FormData();

    if(data) {
        params.set('app_id', data.app_id);
    }

    switch (action.type) {
        case 'apps':
            return new Promise((resolve, reject) => {
                Axios.get(`${url}/apps`, accessToken)
                    .then((res) => {
                        return resolve(res.data.data);
                    })
                    .catch(err => {
                        return reject(err);
                    })
            });

        case 'users':
            return new Promise((resolve, reject) => {
                Axios.get(`${url}/user/${data._id}`, accessToken)
                    .then((res) => {
                        return resolve(res.data.data);
                    })
                    .catch(err => {
                        return reject(err);
                    })
            });   

        case 'log/create':
            return new Promise((resolve, reject) => {
                Axios.post(`${url}/apps/log/create`, params, accessToken)
                    .then((res) => {
                        return resolve(res.data.data);
                    })
                    .catch(err => {
                        return reject(err);
                    })
            });
    
        default:
            return [];
    }
}

export default DashboardAction;